export default {
    toggleCreateShopWindowDialog(context){
        context.commit('toggleCreateShopWindowDialog')
    }
}